import { makeStyles } from '@mui/styles'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeStyles((theme) => ({
    root: {
        maxWidth: '740px',
        margin: '0 auto',
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '16px',
        marginBottom: '18px',
        '@media (max-width:700px)': {
            flexDirection: 'column',
        },
    },
    topTitle: {
        fontSize: '1.5rem',
        color: '#1A1B1E',
    },
    topDescription: {
        fontWeight: 600,
        fontSize: '1rem',
        color: '#808489',
    },
    dropZone: {
        position: 'relative',
        minHeight: '130px',
        background: '#FBFBFE',
        borderRadius: '14px',
        border: '2px dashed #B6C0CF',
        padding: '34px',
        cursor: 'pointer',
        '@media (max-width:700px)': {
            width: '100%',
            padding: 0,
        },
    },
    containerZone: {
        position: 'relative',
        minHeight: '130px',
        background: '#FFF',
        borderRadius: '14px',
        border: '2px dashed #B6C0CF',
        padding: '34px',
        cursor: 'pointer',
        '@media (max-width:700px)': {
            padding: '34px',
        },
    },
    dropItemsContainer: {
        width: '100%',
    },
    hiddenInput: {
        display: 'none',
    },
    dropHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        textAlign: 'center',
    },
    dropText: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        fontSize: '16px',
    },
    dropIcon: {
        marginTop: '10px',
    },
    dropMainText: {
        fontFamily: 'Averta',
        fontWeight: 600,
        fontSize: '1rem',
        color: '#313336',
        textAlign: 'center',
    },
    underlineSvg: {
        position: 'absolute',
        bottom: '-2px',
        left: 0,
        width: '100%',
        height: '5px',
    },
    dropSubText: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '14px',
        color: '#6B6F76',
        textAlign: 'center',
    },
    dropSubTextError: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '14px',
        color: defaultPalette.error.main,
        textAlign: 'center',
    },
    dropErrorRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    dropErrorIcon: {
        color: defaultPalette.error.main,
        fontSize: '20px !important',
    },
    dropErrorText: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '14px',
        color: defaultPalette.error.main,
        textAlign: 'center',
    },
    addButton: {
        background: '#313336 !important',
        borderRadius: '8px',
        height: 60,
        padding: '18px 32px 18px 25px !important',
        flexShrink: 0,
        boxShadow: 'none',
        '& .MuiButton-startIcon': {
            marginRight: '6px',
            marginLeft: '6px',
        },
        '&:hover': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Def... Remove this comment to see the full error message
            background: theme.palette.typography.hover,
        },
        '@media (max-width:700px)': {
            width: '100%',
        },
    },
    sectionTitle: {
        fontFamily: 'AvertaPE-SemiBold',
        fontSize: '16px',
        color: '#313336',
    },
    cardsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '24px',
        width: '100%',
    },
    cardItem: {
        flex: '0 0 157px',
        width: '157px',
        minWidth: 0,
    },

    containerCard: {
        width: '100%',
        background: '#FFF',
        borderRadius: '16px',
        padding: '34px',
        boxShadow: '0 16px 56px 0 rgba(52, 52, 52, 0.05)',
        gap: '1.5rem',
        boxSizing: 'border-box',
    },
    containerCardPJ: {
        width: '100%',
        background: '#FFF',
        borderRadius: '20px',
        boxShadow: '0 16px 56px 0 rgba(52, 52, 52, 0.05)',
        border: '1px solid #E5E9F2',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
    },
    thumb: {
        width: '100%',
        height: '140px',
        background: '#FCFBFE',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        borderBottom: '1px solid #E5E9F2',
        boxSizing: 'border-box',
    },
    thumbImg: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    thumbIconWrap: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#575BAF',
    },
    thumbIcon: {
        fontSize: 28,
    },
    cardName: {
        fontFamily: 'Averta',
        fontWeight: 600,
        fontSize: '13px',
        color: '#1A1B1E',
        textAlign: 'center',
        marginTop: '10px',
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    cardActionsRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '8px',
        padding: '0.625rem',
    },
    actionButton: {
        width: 36,
        height: 36,
        borderRadius: '10px',
        border: '1.5px solid #D8DEE8',
        color: '#1A1B1E',
        '&:hover': {
            background: '#F5F6FA',
        },
    },
    actionButtonDelete: {
        width: 36,
        height: 36,
        borderRadius: '10px',
        border: '1.5px solid #FB355D',
        background: 'rgba(251, 53, 93, 0.08)',
        color: '#FFF5F7',
        '&:hover': {
            background: 'rgba(251, 53, 93, 0.15)',
        },
    },
    cardName: {
        fontFamily: 'Averta',
        fontWeight: 600,
        fontSize: '13px',
        color: '#1A1B1E',
        textAlign: 'center',
        marginTop: '10px',
        width: '157px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    dialogPaperNoScroll: {
        overflow: 'hidden',
        '& .MuiDialogContent-root': {
            overflow: 'hidden',
        },
    },
    helpDraftTitle: {
        color: '#313336',
        fontFamily: 'AvertaPE-Bold',
        fontSize: '21px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '29px',
        letterSpacing: '0.15px',
        margin: 0,
    },
    helpDialogPaper: {
        width: '100%',
        maxWidth: '614px',
        margin: '0 auto',
        borderRadius: '24px',
        '@media (max-width:700px)': {
            margin: '16px',
            width: 'calc(100% - 32px)',
            borderRadius: '16px',
        },
    },
    deleteText: {
        width: '100%',
        textAlign: 'left',
        alignSelf: 'flex-start',
        marginBottom: '24px',
        marginTop: '-18px',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    deleteBackdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.7) !important',
    },
    cardActions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '8px',
        marginTop: '4px',
    },
    actionIcon: {
        color: '#575BAF !important',
    },
    actionIconDelete: {
        color: '#FB355D !important',
    },
    dialogSubtitle: {
        width: '100%',
        textAlign: 'left',
        alignSelf: 'flex-start',
        marginBottom: '24px',
        marginTop: '-20px',
        fontFamily: 'AvertaPE-Semibold',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: '#4E5054',
    },
    dialogFieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        gap: 8,
    },
    dialogFieldLabel: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#313336',
        textAlign: 'left',
        alignSelf: 'flex-start',
    },
    dialogFieldLabelActive: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#24C3CF !important',
        textAlign: 'left',
        alignSelf: 'flex-start',
    },
    dialogLabelRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    dialogLabelRowError: {
        color: defaultPalette.error.main,
        '& $dialogFieldLabel': {
            color: `${defaultPalette.error.main} !important`,
        },
        '& $dialogFieldLabelActive': {
            color: `${defaultPalette.error.main} !important`,
        },
    },
    dialogErrorIcon: {
        color: `${defaultPalette.error.main} !important`,
    },
    dialogTextField: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
        },
        '& input': {
            textAlign: 'left',
        },
    },
    dialogTextFieldError: {
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.error.main} !important`,
            borderWidth: '2px',
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.error.main} !important`,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: `${defaultPalette.error.main} !important`,
        },
    },
    dialogHelperText: {
        fontSize: '0.875rem',
        fontFamily: 'AvertaPE-SemiBold',
    },
    charLimitRow: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: '4px',
    },
    charLimitText: {
        fontSize: 12,
        color: '#808489',
    },
    containerTextClick: {
        position: 'relative',
        display: 'inline-block',
    },
}))
